import { DefaultService } from '@/services/DefaultService';

export default class GradelinhaService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

	save(obj) {
		return this._http.post(`${this._env}/sales/gridrow`, obj, this._headers).then(res => {
			return res.body;
		}, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacao(obj) {
        return this._http.post(`${this._env}/sales/gridrow/updatesituacao`, obj, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}